import { Text } from "@asayinc/component-library";
import { Box } from "@mui/material";
import React from "react";

interface IBadgeProps {
  id: string;
  backgroundColor: string;
  textColor: string;
  children: React.ReactNode;
}

export function Badge({
  id,
  backgroundColor,
  children,
  textColor,
}: IBadgeProps) {
  return (
    <Box data-testid={`${id}-badge`} width="fit-content">
      <Text
        sx={{
          backgroundColor,
          border: "none",
          borderRadius: "4px",
          px: 2,
          py: 0.75,
          textTransform: "capitalize",
          color: textColor,
        }}
        emphasis="medium"
        variant="body3"
      >
        {children}
      </Text>
    </Box>
  );
}
